import { render, staticRenderFns } from "./ProcessChickPlates.vue?vue&type=template&id=4e040d2a"
import script from "./ProcessChickPlates.vue?vue&type=script&lang=js"
export * from "./ProcessChickPlates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports